var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"name","sort-by":"name","group-by":_vm.grupo,"show-group-by":"","items-per-page":10,"loading-text":"Cargando... Por favor, espere","no-data-text":"No hay datos disponibles","footer-props":{
    'items-per-page-text': 'Resultados por página:',
    'page-text': '{0}-{1} de {2}' 
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }